import type { Distance, SpatialRectangle } from "@pdfking/math"
import type { PlotText } from "@pdfking/renderer-api"
import { PlotFunction } from "@pdfking/renderer-api"

export const CreateText = (
  position: SpatialRectangle<Distance>,
  text: string,
  opts: Partial<PlotText> = {}
) => ({
  enum: PlotFunction.PLOT_TEXT as const,
  position,
  text,
  ...opts,
})
